export default {
  wilate: 'Hematology Benefits Investigation Request Form For wilate',
  nuwiq: 'Hematology Benefits Investigation Request Form For NUWIQ',
  fibryga: 'fibryga® Benefits Investigation Request Form',
  octagam: 'Immunology Benefits Investigation Request Form for octagam® 5% and octagam® 10%',
  cutaquig: 'Immunology Benefits Investigation Request Form for cutaquig®',
  panzyga: 'Immunology Benefits Investigation Request Form for panzyga®',
};
